// extracted by mini-css-extract-plugin
module.exports = {"couponApplyError":"CouponApplyErrorMessage_couponApplyError__R5Ddg","couponApplyErrorMessage":"CouponApplyErrorMessage_couponApplyErrorMessage__M7mtr"};